import styled from 'styled-components';

export const IaBadgeWrapper = styled.span`
  .ia-badge {
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #2f80ed;

    path {
      fill: currentColor;
    }
  }
`;

export const NoticeBox = styled.div`
  display: flex;
  align-items: center;
  background-color: #e8eef6;
  border: 1px solid #6a9dc6;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;

  .ia-badge {
    width: 20px;
    height: 20px;
    font-size: 20px;
    min-width: 20px;
    margin-right: 0.5rem;
    color: #2f80ed;

    path {
      fill: currentColor;
    }
  }
`;
